import { createSelector } from 'reselect';
import { BUILDING_BLOCKS } from '../../constants/buildingBlocks';
import { getIsEditingGridLayouts } from './moduleSelectors';
export const getCategoryToBuildingBlocksMap = createSelector([getIsEditingGridLayouts], isEditingGridLayouts => {
  return isEditingGridLayouts ? {
    CONTAINERS: BUILDING_BLOCKS()
  } : {
    CONTAINERS: []
  };
});